import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { Link, injectIntl } from "gatsby-plugin-intl";
import classnames from "classnames";
import Section from "../section/Section";
import Logo from "../../assets/Logo";
import Grid from "../grid/Grid";
import cssClass from "./Footer.module.scss";

const Footer = ({ intl }) => {
  const data = useStaticQuery(graphql`
    query {
      allContentfulClinic {
        nodes {
          node_locale
          id
          city
          slug
        }
      }
      allContentfulArticle {
        nodes {
          node_locale
          id
          name
          slug
        }
      }
      allContentfulFooter {
        nodes {
          node_locale
          address {
            childMarkdownRemark {
              html
            }
          }
          email
          clinicsListTitle
          articleListTitle
          otherLinksTitle
          copyright
        }
      }
      contentfulUnderstandFertilityPage {
        slug
      }
      contentfulFindYourClinicPage {
        slug
      }
    }
  `);

  const {
    address,
    email,
    clinicsListTitle,
    articleListTitle,
    otherLinksTitle,
    copyright,
  } = data.allContentfulFooter.nodes.filter(
    (node) => node.node_locale === intl.locale
  )[0];

  return (
    <footer className={cssClass.footer}>
      <Section className={cssClass.footerLinksContainer}>
        <Grid columns={4}>
          <div className={cssClass.column}>
            <Link aria-label="To homepage" to="/">
              <Logo colorIcon />
            </Link>
            <address className={cssClass.addressText}>
              <div
                dangerouslySetInnerHTML={{
                  __html: address.childMarkdownRemark.html,
                }}
              />
              <a
                href="mailto:helioshealth@email.com"
                target="_blank"
                rel="noopener noreferrer"
                className={cssClass.emailAddress}
              >
                {email}
              </a>
            </address>
          </div>
          <div className={cssClass.column}>
            <p className={cssClass.columnTitle}>{clinicsListTitle}</p>
            <ul
              className={classnames(cssClass.twoColumnList, cssClass.linkList)}
            >
              {data.allContentfulClinic.nodes
                .filter((clinic) => clinic.node_locale === intl.locale)
                .map((clinic) => (
                  <li key={clinic.id}>
                    <Link to={`/${clinic.slug}`}>{clinic.city}</Link>
                  </li>
                ))}
              <li>
                <Link to={`/${data.contentfulFindYourClinicPage.slug}`}>
                  Other cities
                </Link>
              </li>
            </ul>
          </div>
          <div className={cssClass.column}>
            <p className={cssClass.columnTitle}>{articleListTitle}</p>
            <ul
              className={classnames(cssClass.twoColumnList, cssClass.linkList)}
            >
              {data.allContentfulArticle.nodes
                .filter((article) => article.node_locale === intl.locale)
                .map((article) => (
                  <li key={article.id}>
                    <Link
                      to={`/${data.contentfulUnderstandFertilityPage.slug}/${article.slug}`}
                    >
                      {article.name}
                    </Link>
                  </li>
                ))}
              <li>
                <Link to="/glossary">Glossary</Link>
              </li>
            </ul>
          </div>
          <div className={cssClass.column}>
            <p className={cssClass.columnTitle}>{otherLinksTitle}</p>
            <ul className={cssClass.linkList}>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/">Terms and conditions</Link>
              </li>
            </ul>
          </div>
        </Grid>
      </Section>
      <div className={cssClass.copyrightContainer}>
        <p>{copyright}</p>
      </div>
    </footer>
  );
};

export default injectIntl(Footer);
